'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _omit = require('lodash/omit');
var _omit2 = _interopRequireDefault(_omit);
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _themes = require('@marmalade/themes');
var _input = require('./input');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var InputWithButton = function (_Component) {
  _inherits(InputWithButton, _Component);
  function InputWithButton() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, InputWithButton);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputWithButton.__proto__ || Object.getPrototypeOf(InputWithButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function () {
      _this.props.handleSubmit(_this.props.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(InputWithButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        theme = _props.theme,
        control = _props.control,
        fetching = _props.fetching,
        text = _props.text,
        prominence = _props.prominence,
        validate = _props.validate,
        error = _props.error,
        rest = _objectWithoutProperties(_props, ['theme', 'control', 'fetching', 'text', 'prominence', 'validate', 'error']);
      var inlineWidth = 400;
      return _react2.default.createElement(_glamorous2.default.Div, {
        css: _defineProperty({
          display: 'flex',
          flexFlow: 'row wrap'
        }, (0, _themes.atLeast)(inlineWidth), {
          flexFlow: 'row nowrap'
        })
      }, _react2.default.createElement(_input.Input, Object.assign({}, (0, _omit2.default)(rest, 'handleSubmit'), {
        onChange: control,
        onBlur: validate,
        valid: typeof error !== 'undefined' ? !error.length : undefined
      })), _react2.default.createElement(_button2.default, {
        prominence: prominence,
        text: text,
        css: _defineProperty({
          marginTop: theme.space_xs,
          marginBottom: 0,
          width: '100%'
        }, (0, _themes.atLeast)(inlineWidth), {
          marginTop: 0,
          marginLeft: theme.space_sm,
          width: 'auto'
        }),
        onClick: this.handleSubmit,
        posting: fetching
      }));
    }
  }]);
  return InputWithButton;
}(_react.Component);
InputWithButton.propTypes = {
  theme: _propTypes.object.isRequired,
  handleSubmit: _propTypes.func.isRequired,
  control: _propTypes.func.isRequired,
  value: _propTypes.string,
  fetching: _propTypes.bool,
  prominence: (0, _propTypes.oneOf)(['primary', 'secondary', 'default']),
  text: _propTypes.string.isRequired,
  error: _propTypes.string,
  validate: _propTypes.func
};
InputWithButton.defaultProps = {
  value: '',
  fetching: false,
  prominence: 'primary',
  error: undefined,
  validate: undefined
};
exports.default = (0, _glamorous.withTheme)(InputWithButton);